export default __webpack_public_path__ + "static/media/fullscreen.e51c4436.svg";